import React from 'react'
import { Text, type TextProps } from '@mantine/core'

export type AppTextProps = TextProps;

export default function AppText (props: AppTextProps) {
  return <Text {...props} />
}
